import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import CompanyFeatureFlagsEnum, { CompanyFeatureFlagsTips } from 'ab-enums/companyFeatureFlags.enum';

import { Button } from '@acceligentllc/storybook';

import Checkbox from 'af-components/Controls/Checkbox';
import CustomModal from 'af-components/CustomModal';
import SubmitButton from 'af-components/SubmitButton';

import * as CompanyActions from 'af-actions/companies';

import PreviewItem from '../../Shared/PreviewItem';

type OwnProps = {
	showModal: boolean;
	closeModal: () => void;
	companyWaiverStatus: boolean;
	timeRoundingPolicyFrom: Nullable<string>;
};

type Props = OwnProps & ConnectedProps<typeof connector>;

const EnableCompanyWaiverSettingsEdit: React.FC<Props> = (props) => {
	const {
		closeModal,
		showModal,
		companyWaiverStatus,
		editCompanyWaiverSetting,
		timeRoundingPolicyFrom,
	} = props;

	const [enableWaiverSetting, setEnableWaiverSetting] = React.useState(companyWaiverStatus);

	const renderLabel = React.useCallback(() => {
		return (
			<PreviewItem
				checked={companyWaiverStatus}
				hint={CompanyFeatureFlagsTips.waiverSettings}
				indent={false}
				label={CompanyFeatureFlagsEnum.waiverSettings}
				showCheckbox={false}
			/>
		);
	}, [companyWaiverStatus]);

	const handleChange = React.useCallback((event) => {
		setEnableWaiverSetting(event.target.checked);
	}, []);

	const handleSubmit = React.useCallback(async () => {
		await editCompanyWaiverSetting({ companyWaiverStatus: enableWaiverSetting });

		closeModal();
	}, [editCompanyWaiverSetting, enableWaiverSetting, closeModal]);

	const isDisabled = React.useMemo(() => {
		if (!timeRoundingPolicyFrom || companyWaiverStatus) {
			return true;
		}
		return false;
	}, [companyWaiverStatus, timeRoundingPolicyFrom]);

	return (
		<CustomModal
			closeModal={closeModal}
			modalStyle="info"
			showModal={showModal}
			size="lg"
		>
			<CustomModal.Header
				closeModal={closeModal}
				title="Edit User Waiver Settings"
			/>
			<CustomModal.Body>
				<Row>
					<Col sm={12}>
						<Checkbox
							handleChange={handleChange}
							isChecked={enableWaiverSetting}
							isDisabled={isDisabled}
							label={renderLabel()}
						/>
					</Col>
				</Row>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Cancel"
					onClick={closeModal}
					style="secondary"
				/>
				<SubmitButton
					disabled={isDisabled}
					label="Save"
					onClick={handleSubmit}
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

function mapDispatchToProps() {
	return {
		editCompanyWaiverSetting: CompanyActions.editWaiverSetting,
	};
}

const connector = connect(null, mapDispatchToProps());

export default React.memo(connector(EnableCompanyWaiverSettingsEdit));
